import { SearchLoop } from 'assets/icons';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';

// Where the api looks for the text, as in the invoice list (JBWEB-1270), with its words.
const SEARCH_SCOPES = [
  { value: 'all', fallback: 'Tous' },
  { value: 'company', fallback: 'Entreprise' },
  { value: 'group', fallback: 'Groupe' },
  { value: 'number', fallback: 'N° de facture' },
];

/**
 * The search of the reminders tab (JBWEB-1283), in the header of "Paie &
 * factures": the field then where to look (mockup 7.1). The values are those
 * of `useInvoiceFilters`, the status aside: the reminders have none.
 */
const RemindersSearch = ({
  searchText,
  scope,
  onSearchTextChange,
  onScopeChange,
}) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);

  return (
    <>
      <div className="flex-1 max-w-[260px] text-sm">
        <StyledInput
          type="text"
          placeholder={text('searchPlaceholder', 'Rechercher')}
          imgFront={<SearchLoop wh={16} color="#6B7280" />}
          value={searchText}
          onChange={(event) => onSearchTextChange(event.target.value)}
        />
      </div>
      <div className="max-w-[160px]">
        <select
          aria-label={text('searchScopeLabel', 'Recherche dans')}
          className="w-full h-10 pl-2 pr-3 ft-b border rounded-md text-sm focus:border-yellow-500 focus:outline-none"
          value={scope}
          onChange={(event) => onScopeChange(event.target.value)}
        >
          {SEARCH_SCOPES.map(({ value, fallback }) => (
            <option key={value} value={value}>
              {text(`searchScope.${value}`, fallback)}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default RemindersSearch;
